import * as THREE from 'three'
import { Effects } from '@react-three/drei'
import { extend, useThree, useFrame } from '@react-three/fiber'
import { UnrealBloomPass } from 'three-stdlib'
import { Vector2 } from 'three'
import { useEffect, useState, useRef } from 'react'

extend({ UnrealBloomPass })
declare global {
  namespace JSX {
    interface IntrinsicElements {
      unrealBloomPass: any // ???
    }
  }
}
export const BloomPass = () => {
  return (
    <Effects disableGamma stencilBuffer={true}>
      <unrealBloomPass threshold={1} strength={2} radius={0.5}  />
    </Effects>
  )
}
